import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";

class CustomForms extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {

        }
    }



    render() {
        //let {formname} = this.props.match.params;
        let {formname, lable, withHeader, onBackAction} = this.props;

        let customClass = "field-customization-container org-container";
        let customFrameClass = " cusomform-listout";
        customClass = customClass !== undefined ? customClass : "";

        return (
            <Fragment>
                <div className={`d-flex padding-top-25`}>
                    <div className={'cursor-pointer ml-2 mb-2'} onClick={(e) => {onBackAction(e)}}>
                        <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                    </div>
                </div>
                <LegacyFrame 
                    withHeader={withHeader} 
                    pageTitle={lable} 
                    formname={formname} 
                    customClass={customClass} 
                    customFrameClass={customFrameClass}
                />
            </Fragment>
            
        );
    }
}

export default CustomForms;
